import React from "react";

const SvgIcons = ({ type, id }) => {
  switch (type) {
    case "clone": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-copy"
          >
            <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
            <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
          </svg>
        </>
      );
    }
    case "upload": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-upload"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="17 8 12 3 7 8" />
            <line x1="12" x2="12" y1="3" y2="15" />
          </svg>
        </>
      );
    }
    case "remove": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-x"
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </>
      );
    }
    case "docFile": {
      return (
        <>
          <svg
            {...(id ? { id } : {})}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-file-text"
          >
            <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="16" x2="8" y1="13" y2="13" />
            <line x1="16" x2="8" y1="17" y2="17" />
            <line x1="10" x2="8" y1="9" y2="9" />
          </svg>
        </>
      );
    }
    case "filter": {
      return (
        <>
          <svg
            {...(id ? { id } : {})}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-sliders-horizontal"
          >
            <line x1="21" x2="14" y1="4" y2="4" />
            <line x1="10" x2="3" y1="4" y2="4" />
            <line x1="21" x2="12" y1="12" y2="12" />
            <line x1="8" x2="3" y1="12" y2="12" />
            <line x1="21" x2="16" y1="20" y2="20" />
            <line x1="12" x2="3" y1="20" y2="20" />
            <line x1="14" x2="14" y1="2" y2="6" />
            <line x1="8" x2="8" y1="10" y2="14" />
            <line x1="16" x2="16" y1="18" y2="22" />
          </svg>
        </>
      );
    }
    case "reset": {
      return (
        <>
          <svg
            {...(id ? { id } : {})}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-rotate-ccw"
          >
            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
            <path d="M3 3v5h5" />
          </svg>
        </>
      );
    }
    case "Organization": {
      return (
        <>
          <svg
            {...(id ? { id } : {})}
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              className="cls-1"
              d="M19,390.24c.78-3.1,1.5-6.23,2.37-9.31,7.4-26.28,30-44.75,57.41-47l3.58-.33C70.28,316.1,71.22,296.83,74.75,278,79.07,255,101.28,240,125,242.18c22.43,2.06,40.77,21.15,42,44,.38,7.23.26,14.5,0,21.74-.27,8.45-2.7,14.89-9,25.42H209.1c-.86-1.06-1.62-2.09-2.46-3-11.23-12.6-17.1-27.33-17.26-44.21-.14-14.5-.12-29,0-43.51a66.64,66.64,0,0,1,133.27,0c.12,13.73-.05,27.47,0,41.2.13,18.26-5.83,34.14-18.27,47.54-.5.54-.94,1.12-1.79,2.13h51.44c-12.12-18-11.25-37.83-7-57.23,4.77-22,26.82-36.15,49.75-34.05,22,2,40.18,20.43,41.76,42.62.52,7.22.35,14.49.27,21.74a46.21,46.21,0,0,1-8.44,25.83c8.72,2.59,17.81,4.13,25.87,7.9,20.06,9.38,31.84,25.63,35.91,47.44a17.2,17.2,0,0,0,.87,2.53V435.6c-2.28,5.18-6.29,6.91-11.86,6.86-21.9-.18-43.81-.07-65.71-.07h-5.75c0,13.08-.22,25.56.1,38,.15,5.7-1.58,9.86-6.58,12.59H218c-5.49-3.74-7.37-7.28-6.15-11.62,1.35-4.84,4.94-6.89,12.1-6.89h17.63a7.64,7.64,0,0,0-.2-1.62q-24.25-58.94-48.65-117.81c-.46-1.09-2.8-2.14-4.15-2-33.69,3.26-63.41,31.65-66.68,65.44-1.76,18.18-.76,36.63-1,55,0,.25.3.5.67,1.06,5.17,0,10.55-.17,15.92.05,6.63.27,11.07,6.5,8.45,12.2-1.12,2.44-3.77,4.19-5.72,6.25H108.8c-5-2.72-6.75-6.88-6.58-12.59.34-11.09.11-22.21.09-33.31,0-1.47-.17-2.94-.27-4.71H96.57c-21.9,0-43.81-.11-65.71.08-5.57,0-9.56-1.71-11.86-6.87Zm372.06,84.14c0-16.88.62-33.37-.13-49.8-1.66-36.42-31-67.43-66.9-71.63-3-.36-4.25.35-5.41,3.17Q295.1,413.6,271.32,471c-.42,1-.66,2.15-1,3.42ZM207.89,261.69c0,8.69-.14,16.84,0,25a48.14,48.14,0,0,0,33.41,44.76c19.4,6.31,40.64-.65,53.21-17,12.36-16.07,9.33-34.56,9.48-52.78a100.94,100.94,0,0,1-45.78-11.51A5.27,5.27,0,0,0,254,250C239.75,257.6,224.5,261.3,207.89,261.69Zm201.73,162h64.86c0-8,0-15.87,0-23.69-.09-27.78-19.77-47.58-47.44-47.67-17.13-.05-34.25,0-51.38,0-1.28,0-2.55.16-4.53.29C394.49,371,407.12,394.51,409.62,423.65Zm-269-71.37H85.72c-1.7,0-3.4,0-5.09.09a46,46,0,0,0-41,32.23c-3.8,12.82-1.48,25.95-2.07,38.93h64.66C109.25,386.28,111,383,140.57,352.28ZM256,459.47c15-36.41,29.51-71.54,44.11-107H265.24c0,7.42.07,14.63,0,21.83a8.88,8.88,0,0,1-6.67,9,8.11,8.11,0,0,1-9.76-3.33,14.06,14.06,0,0,1-2-6.9c-.25-6.86-.09-13.73-.09-20.58H211.87ZM148.85,297l-.31,0c0-2.92.09-5.85,0-8.77-.54-15-12.43-27.12-27-27.61-15.61-.52-28.34,10.23-29.6,25.63a134,134,0,0,0,0,22.13,28.24,28.24,0,0,0,55.85,2.41C148.68,306.24,148.54,301.56,148.85,297Zm214.22.22.38,0c0,2.92-.08,5.85,0,8.77a28.62,28.62,0,0,0,27.4,27.75c15.12.47,27.94-10.51,29.17-25.67a135.24,135.24,0,0,0-.08-22.59c-1.18-13.53-12.8-24.28-26.07-24.89-14.37-.67-26.78,8.35-29.54,21.94C363.37,287.3,363.46,292.29,363.07,297.19ZM303.81,243c.95-16.37-9.07-33.82-24.58-42.08-17.27-9.2-34.51-8.38-50.67,2.68C215,212.91,208.42,226.24,207.87,243c14.27,0,27.23-3.17,38.79-10.38,6.65-4.15,11.94-4.25,18.62-.07C276.83,239.8,289.81,242.92,303.81,243Z"
            />
            <path
              className="cls-1"
              d="M259.7,19c8.26,2.59,12.82,8.36,15,16.61,1.63,6.24,4,12.28,5.87,18.48.74,2.53,2,3.38,4.58,3.32,7.24-.15,14.5-.11,21.74,0,10.14.11,16.81,4.51,19.38,12.64,2.62,8.3-.17,15.57-8.34,21.56Q308,98.82,298.11,106c-.11.08-.15.26-.42.77,2.52,7.74,5.16,15.75,7.73,23.79,2.94,9.22.78,16.92-6.07,21.85-7,5.05-14.67,4.77-22.65-.93-6.65-4.75-13.23-9.58-19.85-14.37a5.42,5.42,0,0,0-1.14-.41c-6.7,4.86-13.51,9.87-20.4,14.79-8,5.7-15.68,6-22.65.92s-9-12.63-6.09-21.85c2.3-7.18,4.79-14.31,6.87-21.55a5.07,5.07,0,0,0-1.41-4.37c-6-4.63-12.18-8.92-18.28-13.38-7.87-5.77-10.58-13.07-8-21.26,2.49-7.85,9-12.42,18.45-12.63,7.55-.16,15.11-.13,22.66,0,2.59.05,3.84-.77,4.59-3.32,1.82-6.2,4.25-12.23,5.87-18.47,2.14-8.26,6.71-14,15-16.62ZM288,136.84c-3.41-10.42-6.42-19.57-9.4-28.73-2.35-7.18-1.5-9.82,4.55-14.22l24.38-17.73c-2.71-.13-4.19-.27-5.67-.27-8.47,0-17,0-25.43,0-6.3,0-8.89-2-10.86-7.95-2.64-8-5.17-16.11-7.77-24.16-.43-1.33-1-2.62-1.89-5.16-3.38,10.49-6.29,19.56-9.23,28.61-2.23,6.85-4.62,8.64-11.74,8.67-8.63,0-17.26,0-25.89,0-1.08,0-2.16.26-4.22.52,8.46,6.13,16.05,11.63,23.63,17.14,6.56,4.76,7.33,7.16,4.8,14.93-2.93,9-5.86,18-9.23,28.38,8.78-6.39,16.43-12,24.09-17.55,6.44-4.68,9.37-4.69,15.74-.06C271.53,124.83,279.2,130.43,288,136.84Z"
            />
            <path
              className="cls-1"
              d="M176.38,493c-.73-.51-1.47-1-2.2-1.55-3.58-2.62-5.16-6.08-3.77-10.4s4.5-6.58,9-6.48a8.63,8.63,0,0,1,8.52,6.48c1.37,4.33-.2,7.78-3.78,10.4-.72.53-1.46,1-2.19,1.55Z"
            />
          </svg>
        </>
      );
    }
    case "Qualified": {
      return (
        <>
          <svg
            {...(id ? { id } : {})}
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path d="M255.83,133.3a81.65,81.65,0,1,0,81.64,81.64A81.72,81.72,0,0,0,255.83,133.3Zm0,122.47a40.83,40.83,0,1,1,40.82-40.83A40.87,40.87,0,0,1,255.83,255.77ZM500.75,388.54A43,43,0,0,0,488.54,363l-68.67-68.65c.05.19.09.37,0,0h0c0-.12-.06-.26-.06-.2-1.22-5.8,1.09-14.23,6.51-17.72A73.3,73.3,0,0,0,450.84,250a73.06,73.06,0,0,0,0-69.6,73.13,73.13,0,0,0-24.54-26.48c-5.47-3.53-8.26-9.8-6.94-15.61a73.34,73.34,0,0,0-1.22-36.85,71.78,71.78,0,0,0-48.89-48.86,73.12,73.12,0,0,0-36.82-1.21c-5.82,1.29-12.06-1.49-15.59-6.94a73.38,73.38,0,0,0-26.48-24.53,71.71,71.71,0,0,0-69.13,0,73.33,73.33,0,0,0-26.45,24.51c-3.54,5.47-9.76,8.27-15.62,7a73,73,0,0,0-36.8,1.21,71.84,71.84,0,0,0-48.89,48.86,73.36,73.36,0,0,0-1.22,36.85c1.3,5.79-1.47,12.06-7,15.61a73.5,73.5,0,0,0-24.52,26.48,73.21,73.21,0,0,0,0,69.6,73.54,73.54,0,0,0,24.56,26.49c5.41,3.49,7.63,12.29,6.43,18.09a.62.62,0,0,1,0,.22h0L23.38,363.11A42.73,42.73,0,0,0,49,435.69l24.49,2.72,2.67,24.1A42.85,42.85,0,0,0,118.8,501a42.13,42.13,0,0,0,30.11-12.51L225,412.38a71.89,71.89,0,0,0,62-.12l76,76A42.46,42.46,0,0,0,393.26,501a42,42,0,0,0,14.16-2.45,42.59,42.59,0,0,0,28.36-35.78l2.71-24.33L463,435.69a42.8,42.8,0,0,0,37.79-47.13ZM118.17,460l-1.29-1.77L110.5,401.4l-57-6.33c-1-.1-1.82-1.06-1.23-3.18L100,344.23a71.89,71.89,0,0,0,42.42,33.52A73.35,73.35,0,0,0,179.2,379c5.47-1.27,11.39,1.18,15,6.08l-76,75Zm164.4-96.22a33,33,0,0,1-12,11,31.2,31.2,0,0,1-29.55,0,32.94,32.94,0,0,1-11.94-11A56.41,56.41,0,0,0,182,337.84a53.25,53.25,0,0,0-11.86,1.33,33.13,33.13,0,0,1-16.55-.66,31.05,31.05,0,0,1-20.89-20.88,33,33,0,0,1-.63-16.55c5.1-22.45-4.8-46.13-24.61-58.93a33,33,0,0,1-11-12,32.39,32.39,0,0,1,0-30,33.08,33.08,0,0,1,11-12c19.84-12.8,29.72-36.47,24.64-59a33,33,0,0,1,.65-16.55,31,31,0,0,1,20.89-20.86,33.29,33.29,0,0,1,16.53-.65c22.41,5.1,46.15-4.78,59-24.64a33.12,33.12,0,0,1,11.94-11,31.2,31.2,0,0,1,29.55,0,33,33,0,0,1,12,11c12.79,19.84,36.49,29.7,58.92,24.62a33.39,33.39,0,0,1,16.56.65A31.13,31.13,0,0,1,379,112.68a32.89,32.89,0,0,1,.63,16.55c-5.1,22.46,4.78,46.15,24.62,58.93a33.08,33.08,0,0,1,11,12h0a31,31,0,0,1,3.69,15.11,30.61,30.61,0,0,1-3.69,14.92,33,33,0,0,1-10.94,12c-19.84,12.8-29.74,36.5-24.64,58.93a33,33,0,0,1-.63,16.57,31.11,31.11,0,0,1-20.9,20.88,32.76,32.76,0,0,1-16.52.66c-22.41-5.09-46.13,4.79-58.94,24.63Zm175.9,31.29-57,6.33-6.3,56.81L394,459.94l-2-.43H392l-74.48-74.46c3.61-4.9,9.49-7.37,15-6.1a73.37,73.37,0,0,0,36.8-1.21,71.83,71.83,0,0,0,42.46-33.57L460.17,393a1.93,1.93,0,0,1-1.7,2.1ZM91.72,294.75h0c0-.16.08-.33.06-.22a.72.72,0,0,1,0,.22Z" />
          </svg>
        </>
      );
    }
    case "Xbenefits": {
      return (
        <>
          <svg
            {...(id ? { id } : {})}
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path d="M375.64,475.83h-6.22c-55,0-110-.38-165.07.14-35.94.33-65.87-11.94-90.84-37.87-24.36-25.28-49.65-49.66-74.36-74.61-26.58-26.85-22.64-69,8.16-89.49a56.33,56.33,0,0,1,65.3,1.79c17.91,13.36,35.21,27.54,52.78,41.36l6.09,4.76c.73-1,1.46-1.91,2-2.88,10.08-17.82,25.49-26.66,45.82-27.22,13.42-.37,26.86-.45,40.25-1.26,4-.25,8.19-2,11.75-4,33.31-18.81,68.09-22.52,104.51-10.77.81.27,1.66.43,2.75.71,5.52-10.2,13.48-17.37,24.94-19.91a44.39,44.39,0,0,1,9.35-.92q19.9-.15,39.82,0c22.4.15,37.79,15.58,37.81,38q.08,86.49,0,173c0,22.26-15,37.68-37.19,38.15-13.62.29-27.25.27-40.87,0C393.2,504.43,381.45,494.1,375.64,475.83Zm-.72-33.55c.14-1.59.27-2.44.27-3.3,0-41.23,0-82.45.12-123.68,0-3.68-1.79-4.79-4.52-5.87-26.7-10.6-52.89-9.55-78.32,3.9-15.91,8.41-32.65,13.07-50.68,12.77-7.15-.12-14.3-.82-21.44-.66-10,.24-17.42,6.47-19.25,15.39-2.67,13.08,6.53,23.76,20.78,23.83,24.27.1,48.55,0,72.82.06,10.53,0,17.71,6.86,17.76,16.52s-7.12,16.88-17.47,16.94c-25.67.14-51.35.54-77-.15-21.62-.57-37.22-11.38-46.46-31.12a12.59,12.59,0,0,0-3.19-4.61c-25.3-20.08-50.6-40.18-76.09-60-9.75-7.59-22.92-6-31.27,3-9.29,10-8.52,24,2.11,34.67,25.14,25.25,50.65,50.13,75.47,75.7,17.87,18.43,39.1,26.92,64.66,26.75,55-.36,110-.11,165-.11Zm82-62c0-28.29-.1-56.58.1-84.86,0-4.88-1.57-6.4-6.34-6.29-12,.25-24.09.2-36.14,0-4.16-.06-5.91,1.12-5.9,5.63q.17,85.38,0,170.78c0,4.36,1.53,5.88,5.79,5.82,11.69-.16,23.39,0,35.09-.06,7.28,0,7.4-.13,7.4-7.22Z" />
            <path d="M224.19,7a54.12,54.12,0,0,1,31,9.75c5.19,3.59,10.8,5.09,17.13,5.49,24,1.53,41.05,13.5,50.32,35.75a42.23,42.23,0,0,0,12,16.67c18.2,15.43,24.51,35.12,18.82,58.32a41.11,41.11,0,0,0,0,20.08c5.59,23.19-.72,42.86-19,58.26a40.42,40.42,0,0,0-11.78,16.24c-8.75,21.47-24.86,33.71-48,35.81a50,50,0,0,0-22,7.17c-19.89,11.91-40.19,11.51-59.88-.76a39.13,39.13,0,0,0-18.55-6.2c-25-1.76-41.69-14.65-51.13-37.83a36.07,36.07,0,0,0-9.7-13.2C94.19,196,87.48,175.84,93.66,151a35.47,35.47,0,0,0-.06-16.36c-5.95-24.55.53-44.61,19.6-61.14a38.14,38.14,0,0,0,10.2-14.08c9.06-22.56,28.26-36.25,52.65-37.59,5.43-.3,11.17-2.68,15.93-5.52C202,10.36,212.52,6.9,224.19,7Zm-99,159.32c-.24,7.94,2.31,14.56,8.72,19.34a59,59,0,0,1,21.22,29.17,20.48,20.48,0,0,0,13.65,13.46A64.68,64.68,0,0,0,180,230.74c11.29,1.56,22.32,3.34,31.59,11.11a15.68,15.68,0,0,0,15.91,2.63c7-2.68,13.74-5.88,20.48-9.11C255,232,262,229.69,270,230A21.8,21.8,0,0,0,292,214c2.09-7.53,6.21-13.56,11.54-19,4.16-4.23,8.53-8.29,12.46-12.73,5.6-6.33,7.73-13.79,4.66-21.88-2.92-7.67-2.84-15.37-1.71-23.22.71-5,1.79-10,2.39-15,1-8.68-.76-16.73-8.37-21.8-7.91-5.29-13-12.48-17-20.79-2-4.09-4-8.15-6.28-12.06-4.7-8.09-11.74-11.57-21.19-12-6.61-.34-13.28-2.33-19.6-4.51-5.22-1.79-10-5-14.94-7.51-7.23-3.66-14.44-3.46-21.61.23-2.32,1.2-4.71,2.3-7,3.61-9.19,5.33-18.72,8.75-29.71,8.64-9.76-.11-17.35,5.3-20.23,14.65-3.08,10-9,17.57-16.31,24.49a102,102,0,0,0-8.71,9.06c-5.68,6.85-6.68,14.31-4,23,1.78,5.82,2,12.34,1.7,18.5C127.86,152.55,126.22,159.42,125.15,166.32Z" />
            <path
              className="cls-1"
              d="M265.39,119.35c-1.33-7.79-4.63-13-11.18-15.85-7-3-13.41-1.54-18.77,3.77Q211.65,130.91,188,154.73c-6.91,7-6.86,17.47-.3,24s16.91,6.61,24-.36c15.92-15.71,31.8-31.46,47.34-47.53C262,127.81,263.32,123.22,265.39,119.35ZM176,108.41c0,9,7.31,16.55,16,16.6s16.19-7.55,16.34-16.42-7.8-17.13-16.42-17S176,99.47,176,108.41Zm66,65.76c-.07,9.05,7.09,16.67,15.79,16.81,8.86.15,16.59-7.69,16.52-16.74-.06-8.73-7.76-16.67-16.2-16.7S242,165.26,242,174.17Z"
            />
            <path d="M265.39,119.35c-2.07,3.87-3.4,8.46-6.34,11.49-15.54,16.07-31.42,31.82-47.34,47.53-7.07,7-17.37,6.93-24,.36s-6.61-17,.3-24q23.55-23.88,47.41-47.46c5.36-5.31,11.78-6.77,18.77-3.77C260.76,106.31,264.06,111.56,265.39,119.35Z" />
            <path d="M176,108.41c0-8.94,7.33-16.69,15.95-16.82s16.56,8.1,16.42,17S200.63,125.05,192,125,176,117.4,176,108.41Z" />
            <path d="M242,174.17c.06-8.91,7.56-16.66,16.11-16.63s16.14,8,16.2,16.7c.07,9-7.66,16.89-16.52,16.74C249,190.84,241.88,183.22,242,174.17Z" />
          </svg>
        </>
      );
    }
    case "Affiliate": {
      return (
        <>
          <svg
            {...(id ? { id } : {})}
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path d="M105,199C99.54,185.9,94.25,173.3,89,160.71c-3-7.24-6.44-14.36-9-21.76-1.6-4.53-3.88-5.88-8.68-5.89A61.12,61.12,0,0,1,10,71c.33-28.07,19.41-52.06,47-59C83.36,5.34,112,17.88,125.28,41.87a62,62,0,0,1-11.56,74.57c-1.18,1.13-2.38,2.23-3.8,3.55,9.31,22.09,18.52,44.15,28.07,66.07.54,1.23,3.95,2,5.82,1.73a156.75,156.75,0,0,1,69.49,4.74,158.6,158.6,0,0,1,48.9,24.52l93-86.25c-.56-1.26-1-2.41-1.55-3.49-26.39-50.15,3.3-108.66,59.26-116.74,40.44-5.85,80.63,23.39,87.82,63.9,7.48,42.14-19.41,83-60.29,91.71-19.81,4.24-38.51,1.33-56.22-8.3-2.36-1.29-4.06-2.4-6.66,0q-43.74,40.85-87.67,81.46c-.52.49-.92,1.1-.59.71,7.83,13.34,15.83,25.95,22.77,39.12,5.79,11,5.24,11.25,17.51,9.06,14.39-2.56,28.75-5.42,43.21-7.5,5-.72,6.4-2.73,7.23-7.37,4.56-25.64,19.44-42.94,44.56-49.56s47.26.63,63.92,20.94c22,26.77,16.45,66.88-11.43,87.67C449.62,352.9,409.8,346.37,390,318.3c-1.24-1.76-3.93-4-5.58-3.75-19.63,3.14-39.2,6.72-58.83,10.2,0,11.3.69,22.27-.19,33.11s-3.34,21.55-5.19,32.88l38.45,8.87c8.72,2,17.5,3.79,26.17,6,3.34.87,5.07,0,7.22-2.64,15.8-19.54,36.42-27.46,60.91-22.31s40.47,20.44,47,44.74c9,33.36-12.53,68-46.3,75.35-34.44,7.44-68.28-15.57-73.77-50.18-1.66-10.49-1.65-10.55-12.08-13-19.41-4.47-38.86-8.78-58.24-13.37-3.63-.86-5.39.11-7.43,3.21-33.23,50.42-80.11,75.67-140.54,74.43a145.25,145.25,0,0,1-80.77-26.35C31.5,441.45,6.89,393.88,10.61,334.19c3.8-60.74,35.27-104.78,89.25-132.74C101.31,200.7,102.8,200,105,199Zm155.42,226c41.71-46.29,42.91-124.07-9.56-172-50.71-46.31-130.84-41.52-175.54,10.15-45.89,53-34.34,125.76-.2,160.59C82,415.55,88.28,406.65,96,399.35s17.19-13.19,25.83-19.65c-33.32-30.85-29.45-76-4.15-102.08a69.8,69.8,0,0,1,95.05-5.18C227.34,284.55,236,300.15,238,319c2.52,24.42-6.53,44.63-24.63,61.49C233.68,390.74,249.22,405.24,260.45,424.94ZM423.2,45.09a43.92,43.92,0,0,0-44.28,43.55c-.1,24.34,19.36,44.29,43.43,44.5a44,44,0,1,0,.85-88ZM232.42,448.54c-7.59-23.77-35.34-42.65-63.16-43-29-.35-57,18-65.46,42.88C139.79,472.75,194.89,473.47,232.42,448.54ZM133,326.09a35.13,35.13,0,1,0,35.63-34.75A34.92,34.92,0,0,0,133,326.09ZM70.87,98.14c14.76.2,26.92-11.47,27-26S86.59,45.6,72.36,45.32C57.52,45,45.25,56.56,45,71,44.82,85.8,56.37,98,70.87,98.14ZM414,440.32A26.43,26.43,0,1,0,441,414.24,26.45,26.45,0,0,0,414,440.32Zm0-157.45c0,14.7,12,26.75,26.45,26.62A26.52,26.52,0,1,0,414,282.87Z" />
          </svg>
        </>
      );
    }
    case "plus": {
      return (
        <>
          <svg
            {...(id ? { id } : {})}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-plus"
          >
            <path d="M5 12h14" />
            <path d="M12 5v14" />
          </svg>
        </>
      );
    }
    case "check": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-check"
          >
            <path d="M20 6 9 17l-5-5" />
          </svg>
        </>
      );
    }
    case "image": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-image"
          >
            <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
            <circle cx="9" cy="9" r="2" />
            <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
          </svg>
        </>
      );
    }
    case "video": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-video"
          >
            <path d="m22 8-6 4 6 4V8Z" />
            <rect width="14" height="12" x="2" y="6" rx="2" ry="2" />
          </svg>
        </>
      );
    }
    case "edit": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-pencil"
          >
            <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
            <path d="m15 5 4 4" />
          </svg>
        </>
      );
    }
    case "delete": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-trash-2"
          >
            <path d="M3 6h18" />
            <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
            <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
            <line x1="10" x2="10" y1="11" y2="17" />
            <line x1="14" x2="14" y1="11" y2="17" />
          </svg>
        </>
      );
    }
    case "pdf": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-file-text"
          >
            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
            <path d="M14 2v4a2 2 0 0 0 2 2h4" />
            <path d="M10 9H8" />
            <path d="M16 13H8" />
            <path d="M16 17H8" />
          </svg>
        </>
      );
    }
    case "success": {
      return (
        <>
          <svg
            {...(id ? { id } : {})}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-badge-check"
          >
            <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
            <path d="m9 12 2 2 4-4" />
          </svg>
        </>
      );
    }
    case "filed": {
      return (
        <>
          <svg
            {...(id ? { id } : {})}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-shield-alert"
          >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
            <path d="M12 8v4" />
            <path d="M12 16h.01" />
          </svg>
        </>
      );
    }
    case "warning": {
      return (
        <>
          <svg
            {...(id ? { id } : {})}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-alert-circle"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" x2="12" y1="8" y2="12" />
            <line x1="12" x2="12.01" y1="16" y2="16" />
          </svg>
        </>
      );
    }
    case "import": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-download"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" x2="12" y1="15" y2="3" />
          </svg>
        </>
      );
    }
    case "pause": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-pause"
          >
            <rect width="4" height="16" x="6" y="4" />
            <rect width="4" height="16" x="14" y="4" />
          </svg>
        </>
      );
    }
    case "play": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-play"
          >
            <polygon points="5 3 19 12 5 21 5 3" />
          </svg>
        </>
      );
    }
    default: {
      return <></>;
    }
  }
};

export default SvgIcons;
